import { AxiosResponse, isAxiosError } from 'axios';
import { captureException } from '@sentry/nextjs';

import { environment } from '@app/environments/environment';

const onResponseSuccess = (response: AxiosResponse): AxiosResponse => response;

const onSentryResponseError = (error: unknown) => {
    try {
        // Only send if enabled (avoids noise in local/dev if you prefer)
        if (environment.SENTRY.SENTRY_ENABLED) {
            if (isAxiosError(error)) {
                const method = error.config?.method?.toUpperCase();
                const url = error.config?.url;
                const status = error.response?.status;

                captureException(error, scope => {
                    scope.setTag('layer', 'axios');
                    scope.setTag('kind', 'http_client');
                    if (status) scope.setTag('http.status_code', String(status));

                    // Keep context helpful but avoid dumping request/response bodies (PII risk)
                    scope.setContext('axios', {
                        method,
                        url,
                        status,
                        statusText: error.response?.statusText,
                        timeout: error.config?.timeout,
                    });

                    return scope;
                });
            } else {
                captureException(error);
            }
        }
    } catch {
        // Never let logging break the request flow
    }

    return Promise.reject(error);
};

export const responseInterceptors = {
    onSentryResponseError,
    onResponseSuccess,
};
